import hasPermission from "@/hooks/hasPermission";
import { useState } from "react";
import { Link } from "react-router-dom";
import { TabsContent } from "@/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";
import Paginat from "@/components/lib/paginat";
import { Button } from "@/components/ui/button";
import TableData from "./table";
import { Search } from "lucide-react";
import { useFilter } from "@/hooks/useFilter";
import { useSelector } from "react-redux";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";

function PartyTabs() {
  const { partyPlatters } = useSelector((state) => state.menuManage.party);

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(partyPlatters, filters, {
    delay: 300,
    defaultFilter: (item) =>
      item?.status !== "draft" &&
      (filters.status === "archived" ? item?.status === "archived" : item?.status !== "archived"),
  });
  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description"],
    300
  );

  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent className="mt-5" value="day">
      <div className="w-full my-5 flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
        <div className="w-[260px]">
          <div className="relative">
            <Search size={18} className="text-cwhite3 absolute top-2 left-2" />
            <Input
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search"
              className="bg-cblack3 pl-8"
            />
          </div>
        </div>
        <div className="flex flex-col  gap-1.5 justify-end items-end">
          <div className="flex gap-3 justify-center items-center">
            <div className="relative">
              <Select
                onValueChange={(value) =>
                  setFilters((prev) => ({
                    ...prev,
                    status: value === "0" ? "" : value,
                  }))
                }
              >
                <SelectTrigger className="w-[100px]">
                  <SelectValue placeholder="Status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="0">All</SelectItem>
                  <SelectItem value="active">Active</SelectItem>
                  <SelectItem value="inactive">Inactive</SelectItem>
                  <SelectItem value="archived">Archived</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button
              className={"bg-cblack3 border border-gray-600 text-cwhite2"}
            >
              <FileDown /> Export
            </Button>
            <div className="flex gap-1 justify-center items-center">
              <h3 className="text-white">Show</h3>
              <Select
                onValueChange={(value) => setPerPage(Number(value))}
                value={perPage.toString()}
              >
                <SelectTrigger className="w-[60px]">
                  <SelectValue placeholder="10" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="10">10</SelectItem>
                    <SelectItem value="20">20</SelectItem>
                    <SelectItem value="40">40</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
            {hasPermission("back_office.menu_management.create_special_menu") && (
  <Link
              to={"/backoffice/menu/special-menu/party-platter-sample/create"}
            >
              <Button>
                <Plus size={20} />
                Party/Occasion Platter Sample
              </Button>
            </Link>
)}
          </div>
        </div>
      </div>
      <div>
        <TableData data={paginatedData} />
      </div>
      <Paginat
        pagination={paginationInfo}
        onPageChange={onPageChange}
        className="mt-4"
      />
    </TabsContent>
  );
}

export default PartyTabs;
